export const findLastIndexWhere = <T>(
	data: T[],
	predicate: (item: T) => boolean,
): number => {
	let low = 0;
	let high = data.length - 1;
	let result = -1;

	while (low <= high) {
		const mid = (low + high) >> 1;
		if (predicate(data[mid])) {
			result = mid;
			low = mid + 1;
		} else {
			high = mid - 1;
		}
	}

	return result;
};
